import ApiCaller from './ApiCaller';
import baseAjaxConfig, { headers } from './BaseAjaxConfig';
import isEmpty from 'lodash/isEmpty';

export const GET_SWATCHES_REQUEST = 'GET_SWATCHES_REQUEST';
export const GET_SWATCHES_SUCCESS = 'GET_SWATCHES_SUCCESS';
export const GET_SWATCHES_ERROR = 'GET_SWATCHES_ERROR';

export function getSwatchesAction(pids) {
	return { type: GET_SWATCHES_REQUEST, pids };
}

export function getSwatchesSuccessAction(pids, data) {
	return { type: GET_SWATCHES_SUCCESS, pids, data };
}

export function getSwatchesErrorAction(pids, error) {
	return { type: GET_SWATCHES_ERROR, pids, error };
}

export function fetchSwatchesAction(pidLidMap, pinCode, snippetContext, showSuperTitle = false) {
	return (dispatch, getState) => {
		const { swatches } = getState();
		const productIds = Object.keys(pidLidMap);

		const pidsNotInStore = productIds.filter(pid => (swatches.productSwatchDetails[pid] ? false : pid));

		if (pidsNotInStore.length) {
			dispatch(getSwatchesAction(productIds));

			if (!isEmpty(pidLidMap)) {
				const reqBody = { pidLidMap };
				if (!pinCode) {
					reqBody.pincode = pinCode;
				}
				if (snippetContext) {
					reqBody.snippetContext = snippetContext;
				}
				if (showSuperTitle) {
					reqBody.showSuperTitle = showSuperTitle;
				}

				return ApiCaller.post(
					Object.assign({}, baseAjaxConfig, {
						headers,
						pathname: '/api/4/product/swatch'
					}),
					reqBody
				).then(
					json => dispatch(getSwatchesSuccessAction(productIds, json['RESPONSE'])),
					err => dispatch(getSwatchesErrorAction(productIds, err))
				);
			}
		}
		return null;
	};
}
